import React, { useEffect, useState } from 'react';
import { useLaunchCountdown } from '../hooks/useLaunchCountdown';
import { pricing } from '../data/content';
type Phase = 'shown' | 'leaving' | 'gone';
export function UrgencyBar() {
  const {
    isActive,
    formatted
  } = useLaunchCountdown();
  const [phase, setPhase] = useState<Phase>(() => isActive ? 'shown' : 'gone');
  useEffect(() => {
    if (!isActive && phase === 'shown') setPhase('leaving');
  }, [isActive, phase]);
  useEffect(() => {
    if (phase !== 'leaving') return;
    const t = setTimeout(() => setPhase('gone'), 320);
    return () => clearTimeout(t);
  }, [phase]);
  if (phase === 'gone') return null;
  const leaving = phase === 'leaving';
  return <div className={`grid transition-[grid-template-rows,opacity] duration-300 ease-out ${leaving ? 'grid-rows-[0fr] opacity-0' : 'grid-rows-[1fr] opacity-100'}`} data-id="element-247" data-mp="2k70r1qteh0qv">
      <div className="overflow-hidden" data-id="element-248" data-mp="2b62nf9mviv8t">
        <div className="bg-terracotta-deep text-ivory px-3 py-1.5 md:py-2" data-id="element-249" data-mp="2b7401ijjfpsn">
          <p className="max-w-5xl mx-auto flex items-center justify-center gap-2 md:gap-3 font-sans text-[11px] md:text-xs font-semibold tracking-wide" data-id="element-250" data-mp="1rx0zp90o50ab">
            <span className="hidden md:inline-block h-1.5 w-1.5 rounded-full bg-coral" aria-hidden="true" data-id="element-251" data-mp="1wpu764niumq3" />
            <span data-id="element-252" data-mp="1my7mzit7hdb7">PRECIO DE LANZAMIENTO TERMINA EN:</span>
            <span className="font-mono tabular-nums bg-plum rounded px-1.5 py-0.5" data-id="element-253" data-mp="1myzh0p75n2zd">{formatted}</span>
            <span className="hidden md:inline text-ivory/85" data-id="element-254" data-mp="2aobqlq6e9d27">AHORRAS {pricing.savings}</span>
          </p>
        </div>
      </div>
    </div>;
}